module.exports = __webpack_public_path__ + "static/media/mini-program-qrcode.97604289.jpg";